import { useEffect, useMemo } from 'react'

import type { TAbsoluteLocale, TRegionDetail } from '@src/config/localisation/locale-config.types'
import { noop } from '@src/utils/functions/utils'

import { checkRegionChanged } from '../utils'

const useRegionSwitchHandler = ({
  locale,
  regionDetails,
  showConfirmationModal,
}: {
  locale: TAbsoluteLocale
  regionDetails: TRegionDetail
  showConfirmationModal: (locale: TAbsoluteLocale, callback: () => void) => void
}) => {
  const { isRegionChange, targetLocale } = useMemo(() => {
    return checkRegionChanged({
      locale,
      regionDetails,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []) // Run only once on mount - we don't want to recheck region changes after initial load

  useEffect(() => {
    if (isRegionChange) {
      showConfirmationModal(targetLocale as TAbsoluteLocale, noop)
    }
  }, [isRegionChange, targetLocale, showConfirmationModal, regionDetails])
}

export default useRegionSwitchHandler
